import {
	parsePhoneNumberFromString,
	PhoneNumber,
	CountryCode,
} from 'libphonenumber-js'

export const validatePhoneNumber = (
	value: string,
	countryCode: CountryCode,
	validCountries: string[] | undefined
) => {
	if(!validCountries) validCountries = new Array(countryCode)
	let phone: PhoneNumber | undefined
	let isValid = true

	if (countryCode) {
		phone = parsePhoneNumberFromString(value, countryCode)
		isValid = phone
			? phone.isPossible() && phone.country?.toLowerCase() === countryCode?.toLowerCase()
			: false

		if (isValid) return isValid
	}

	phone = parsePhoneNumberFromString(value)
	isValid = phone
		? phone.isPossible() && validCountries.includes(phone.country?.toLowerCase() ?? '')
		: false

	return isValid
}
